import React, { useState } from 'react'
import OfficesAccordionCard from './OfficesAccordionCard/OfficesAccordionCard'

import './OfficesAccordion.css'

const OfficesAccordion = ({ accordionList, title }) => {
    const [list, setList] = useState(accordionList)

    const updateActiveItem = itemsList => {
        return itemsList.map(item => {
            return {
                ...item,
                active: false
            }
        })
    }

    const onToggleCard = e => {
        const id = parseInt(e.target.getAttribute('data-id'))
        const activeItem = list.filter(item => id === item.id)[0]

        const updatedList = updateActiveItem(list)
        setList(updatedList)

        if (!activeItem.active) {
            const newList = updatedList.map(item => {
                if (item.id === id) {
                    activeItem.active = true
                    return activeItem
                }

                return item
            })

            setList(newList)
        }
    }

    return (
        <div className="offices-accordion">
            <div className="offices-accordion__title">{title}:</div>
            {list.map((item, i) => {
                return (
                    <OfficesAccordionCard
                        accordionItem={item}
                        key={i}
                        onToggleCard={onToggleCard}
                    />
                )
            })}
        </div>
    )
}

export default OfficesAccordion
